var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "picture-modal-template" },
    [
      this.config.add_button_html
        ? _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "outline-secondary" },
              on: { click: _vm.show },
            },
            [_vm._v("\n    " + _vm._s(this.config.add_button_html) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "pictureModal",
          staticClass: "text-sm-left",
          attrs: {
            id: "pictureModal",
            "modal-class": ["picture-modal-template", _vm.modalClass],
            centered: "",
            "hide-footer": "",
          },
          on: { hidden: _vm.hide },
        },
        [
          _c(
            "template",
            { slot: "modal-header" },
            [
              _c(
                "div",
                { staticClass: "modal-photo-container" },
                [
                  _c("picture-placeholder", {
                    attrs: {
                      textIn: _vm.config.modalTitle || _vm.config.title,
                      pictureUrl: _vm.config.pictureUrl,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-toolbar" },
                [
                  _vm._t("modal-toolbar-buttons", function () {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "modal-btn",
                          on: { click: _vm.hideModal },
                        },
                        [_c("i", { staticClass: "fi-x cancel-bro nav-icon" })]
                      ),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.overrideTitle || _vm.config.title) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-nav",
                { staticClass: "modal-nav-bar" },
                _vm._l(_vm.views, function (view, index) {
                  return _c(
                    "b-nav-item",
                    {
                      key: index,
                      class: [
                        "modal-nav-link",
                        {
                          navLinkActive:
                            view &&
                            view.title == _vm.views[_vm.currentActive].title,
                        },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.currentActive = index
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(view ? view.title.toUpperCase() : "") +
                          "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.views, function (view, index) {
            return _c(
              "div",
              {
                key: "slot_" + index,
                class: [
                  "modal-slot-container",
                  { hidden: _vm.currentActive != index },
                ],
              },
              [view ? _vm._t(view.id) : _vm._e()],
              2
            )
          }),
          _vm._v(" "),
          _vm._t("button"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }